import { render, staticRenderFns } from "./typeTip.vue?vue&type=template&id=286ccc40&scoped=true&"
import script from "./typeTip.vue?vue&type=script&lang=js&"
export * from "./typeTip.vue?vue&type=script&lang=js&"
import style0 from "./typeTip.vue?vue&type=style&index=0&id=286ccc40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ccc40",
  null
  
)

export default component.exports